import { GlobalEventBus } from "../events/GlobalEventBus";
import { EventTypes } from "../events/EventTypes";

export class LoadingState {
  private static loadingDiv = document.getElementById('loading') as HTMLDivElement;
  private siteIsLoaded: boolean = false;

  constructor() {
    GlobalEventBus.addEventListener(EventTypes.LOADING, ()=>{
      this.setLoading();
    })
    GlobalEventBus.addEventListener(EventTypes.LOADED, ()=>{
      this.hideLoading();
    })
  }
  setLoading() {
    console.log('loading')
    LoadingState.loadingDiv.style.display = 'block';
  }
  hideLoading() {
    if (this.siteIsLoaded){
      console.log('loaded')
      LoadingState.loadingDiv.style.display = 'none';
    }
  }
  siteLoaded() {
    this.siteIsLoaded = true;
  }
}
